<template>
  <div style="width: 100%;min-height: 100%;background:#f3f3f3;position:absolute;">
    <div class="mainCtn">
      <div class="title">
        <div @click="$router.push('/MyRSservices')" style="position:absolute;top:0px;left:0px;width: 200px;height:45px;line-height: 45px;font-size: 16px;color: #3A3A3A;cursor:pointer;font-weight: normal;text-align: left;">
          <span style="font-size: 18px;">＜</span> &nbsp;返回我的套件
        </div>
        标准版套件订单详情
      </div>
      <div style="width: 100%;height: auto;">
        <div class="progressBarCtn">
          <div class="progressBar">
            <!--圆1-->
            <div class="progressCircle_gray">
              <span>1</span>
              <div v-if="1 <= progressStat" class="progressCircle_blue">
                1
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div class="progressCircle_Text_name">
                  需求确认
                </div>
              </div>
            </div>
            <!--线1-->
            <div class="progressLine_gray">
              <div v-if="1 < progressStat" class="progressLine_blue">
              </div>
            </div>
            <!--圆2-->
            <div class="progressCircle_gray">
              <span>2</span>
              <div v-if="2 <= progressStat" class="progressCircle_blue">
                2
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div class="progressCircle_Text_name">
                  订单提交
                </div>
                <div class="progressCircle_Text_time">
                  {{orderDetail.createTime}}
                </div>
              </div>
            </div>
            <!--线2-->
            <div class="progressLine_gray">
              <div v-if="2 < progressStat" class="progressLine_blue">
              </div>
            </div>
            <!--圆3-->
            <div class="progressCircle_gray">
              <span>3</span>
              <div v-if="progressStat>=3&&orderDetail.status!='已驳回'&&orderDetail.status!='已取消'" class="progressCircle_blue">
                3
              </div>
              <!--当步骤大于3（已交付），且未付款-->
              <div v-if="progressStat>3&&orderDetail.payStatus!='已付款'" class="progressCircle_red">
                3
              </div>
              <!--当步骤等于3，但已被驳回或取消-->
              <div v-if="progressStat==3&&(orderDetail.status=='已驳回'||orderDetail.status=='已取消')" class="progressCircle_red">
                3
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div  class="progressCircle_Text_name">
                  <span v-if="progressStat<3" style="color:#B8B8B8">
                      审核与支付
                  </span>
                  <span v-if="progressStat==3">
                    <span v-if="orderDetail.status=='已驳回'">审核未通过</span>
                    <span v-if="orderDetail.status=='已取消'">已取消</span>
                    <span v-if="orderDetail.status=='待确认'">合同待确认</span>
                    <span v-if="orderDetail.status=='已确认'&&orderDetail.payStatus=='未付款'">合同已确认</span>
                    <span v-if="orderDetail.status=='已确认'&&orderDetail.payStatus=='已付款'">已付款</span>
                  </span>
                  <span v-if="progressStat>3">
                    <span v-if="orderDetail.payStatus=='未付款'">
                      未付款
                    </span>
                    <span v-if="orderDetail.payStatus=='已付款'">
                      已付款
                    </span>
                  </span>
                </div>
                <!--时间-->
                <div v-if="progressStat>=3" class="progressCircle_Text_time">
                  <span v-if="progressStat==3">
                    <span v-if="orderDetail.status=='已驳回'">{{ orderDetail.contractConfirmTime }}</span>
                    <span v-if="orderDetail.status=='已取消'"></span>
                    <span v-if="orderDetail.status=='待确认'"></span>
                    <span v-if="orderDetail.status=='已确认'&&orderDetail.payStatus=='未付款'">{{ orderDetail.contractConfirmTime }}</span>
                    <span v-if="orderDetail.status=='已确认'&&orderDetail.payStatus=='已付款'">{{ orderDetail.payTime }}</span>
                  </span>
                  <span v-if="progressStat>3">
                    <span v-if="orderDetail.payStatus=='未付款'">
                    </span>
                    <span v-if="orderDetail.payStatus=='已付款'">
                      {{ orderDetail.payTime }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <!--线3-->
            <div class="progressLine_gray">
              <div v-if="3 < progressStat" class="progressLine_blue">
              </div>
            </div>
            <!--圆4-->
            <div class="progressCircle_gray">
              <span>4</span>
              <div v-if="4 <= progressStat" class="progressCircle_blue">
                4
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div class="progressCircle_Text_name">
                  <span v-if="progressStat<4" style="color:#B8B8B8">
                    交付
                  </span>
                  <span v-else>
                    已交付
                  </span>
                </div>
                <!--已交付未下载-->
                <div  class="progressCircle_Text_time">
                  {{orderDetail.postTime}}
                </div>
              </div>
            </div>
            <!--线4-->
            <div class="progressLine_gray">
              <div v-if="4 < progressStat" class="progressLine_blue">
              </div>
            </div>
            <!--圆5-->
            <div class="progressCircle_gray">
              <span>5</span>
              <div v-if="5 <= progressStat" class="progressCircle_blue">
                5
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div class="progressCircle_Text_name">
                  <span v-if="progressStat<5" style="color:#B8B8B8">
                    评价
                  </span>
                  <span v-else>
                    已评价
                  </span>
                </div>
                <div class="progressCircle_Text_time">
                  <span v-if="progressStat==5">
                    {{orderDetail.evaluateTime}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="orderDetailCtn">
        <!--订单详情信息-->
        <div style="width: 100%;height:390px;display: flex;justify-content: start;margin-top: 50px;">
          <!--左侧-->
          <div style="width: 640px;height:100%;border-right: 1px solid #CCCCCC;padding-left: 50px;">
            <div class="orderdetail_title">
              基本信息
            </div>
            <table class="detailTable">
              <tr>
                <td style="width: 124px;color: #979797;">
                  订单号：
                </td>
                <td>
                  {{orderDetail.id}}
                </td>
              </tr>
              <tr>
                <td style="width: 124px;color: #979797;">
                  下单时间：
                </td>
                <td>
                  {{orderDetail.createTime}}
                </td>
              </tr>
              <tr>
                <td style="width: 124px;color: #979797;">
                  选购产品名称：
                </td>
                <td>
                  {{orderDetail.name}}
                </td>
              </tr>
              <tr>
                <td style="width: 124px;color: #979797;">
                  切片名称：
                </td>
                <td v-if="orderDetail.quarters">
                  {{orderDetail.quarters.join("、")}}
                </td>
              </tr>
              <tr>
                <td style="width: 124px;color: #979797;">
                  合同模式：
                </td>
                <td>
                  {{orderDetail.contractType}}
                </td>
              </tr>
              <tr>
                <td style="width: 124px;color: #979797;">
                  发票模式：
                </td>
                <td>
                  <span v-if="orderDetail.invoiceType=='gr'">
                    个人
                  </span>
                  <span v-if="orderDetail.invoiceType=='qy'">
                    普票
                  </span>
                  <span v-if="orderDetail.invoiceType=='zp'">
                    专票
                  </span>
                </td>
              </tr>
              <tr>
                <td style="width: 124px;color: #979797;">
                  订单价格：
                </td>
                <td>
                  ￥{{orderDetail.payFinal}}
                </td>
              </tr>
              <tr>
                <td style="width: 124px;color: #979797;">
                  订单备注：
                </td>
                <td>
                  {{orderDetail.remark}}
                </td>
              </tr>
            </table>
          </div>
          <!--右侧-->
          <div style="width: 639px;height:100%;padding-left:50px;">
            <div class="orderdetail_title">
              流程状态
            </div>
            <table class="detailTable">
              <tr>
                <td style="width: 124px;color: #979797;">
                  订单状态：
                </td>
                <td>
                  {{orderDetail.status}}
                </td>
              </tr>
              <tr>
                <td style="width: 124px;color: #979797;">
                  合同状态：
                </td>
                <td>
                  {{orderDetail.contractStatus}}
                  <span @click="$router.push({path:'/standardContract',query:{id:orderId}})"  v-if="progressStat==3&&orderDetail.status=='待确认'" class="blueTxt" >去确认</span>
                  <span @click="openContract()" v-if="orderDetail.contractStatus=='用户已确认'" class="blueTxt" >查看合同</span>
                </td>
              </tr>
              <tr>
                <td style="width: 124px;color: #979797;">
                  付款状态：
                </td>
                <td>
                  {{orderDetail.payStatus}}
                  <span @click="payThisOrder" class="blueTxt" v-if="orderDetail.contractStatus=='用户已确认'&&orderDetail.payStatus=='未付款'">立即付款</span>
                </td>
              </tr>
              <tr>
                <td style="width: 124px;color: #979797;">
                  交付状态：
                </td>
                <td>
                  {{orderDetail.postStatus}}
                  <!-- <span @click="chooseRepositoryDialog=true" class="blueTxt" v-if="orderDetail.postStatus=='已交付'">去使用</span> -->
                </td>
              </tr>
              <tr>
                <td style="width: 124px;color: #979797;">
                  发票状态：
                </td>
                <td>
                  {{orderDetail.invoiceStatus}}
                  <span @click="applyInvoice()" class="blueTxt" v-if="(orderDetail.invoiceStatus=='已红冲' || orderDetail.invoiceStatus=='未开票')&&orderDetail.contractStatus=='用户已确认'">申请开票</span>
                  <span @click="showInvoice()" class="blueTxt" v-if="orderDetail.invoiceStatus=='已开票'">查看发票</span>
                </td>
              </tr>
              <tr>
                <td style="width: 124px;color: #979797;">
                  用户评价：
                </td>
                <td>
                  {{orderDetail.evaluateStatus}}
                  <span @click="evalueteOrder" class="blueTxt" v-if="orderDetail.payStatus=='已付款'&&orderDetail.postStatus=='已交付'&&orderDetail.evaluateStatus=='未评价'">去评价</span>
                  <span @click="evalueteOrder" class="blueTxt" v-if="orderDetail.payStatus=='已付款'&&orderDetail.postStatus=='已交付'&&orderDetail.evaluateStatus=='已评价'">查看我的评价</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="detailButtonCtn">
          <div class="buttonNormal" @click="cancelDialog=true" v-if="progressStat==2">取消订单</div>
          <div class="buttonNormal" @click="$router.push({path: '/standardContract',query:{id:orderId}})" v-if="progressStat==3&&orderDetail.status=='待确认'">去确认合同</div>
          <div class="buttonNormal" @click="goRSmanageStandard(orderDetail)" v-if="orderDetail.postStatus=='已交付'" style="margin-left: 20px;">使用套件</div>
          <div class="buttonNormal" @click="openContract()" v-if="orderDetail.contractStatus=='用户已确认'" style="margin-left: 20px;">查看合同</div>
          <div class="buttonNormal" @click="showInvoice()" v-if="orderDetail.invoiceStatus=='已开票'"  style="margin-left: 20px;">查看发票</div>
          <div class="buttonPrimary" @click="payThisOrder" v-if="orderDetail.contractStatus=='用户已确认'&&orderDetail.payStatus=='未付款'" style="margin-left: 20px;">
            去付款
          </div>
          <div class="buttonNormal" @click="evalueteOrder" v-if="orderDetail.payStatus=='已付款'&&orderDetail.postStatus=='已交付'&&orderDetail.evaluateStatus=='未评价'" style="margin-left: 20px;">评价订单</div>
          <div class="buttonNormal" @click="evalueteOrder" v-if="orderDetail.payStatus=='已付款'&&orderDetail.postStatus=='已交付'&&orderDetail.evaluateStatus=='已评价'" style="margin-left: 20px;">查看评价</div>
          <div class="buttonNormal" @click="$router.push('/Price')" v-if="orderDetail.status=='已驳回'||orderDetail.status=='已取消'" style="width: 200px;margin-left: 20px;">继续选购标准版套件</div>
        </div>
      </div>
      <div class="bottomTip">
        若您有任何疑问请咨询商务经理：0431-86008580
      </div>
    </div>
    <HomeFooter1></HomeFooter1>
    <!--取消订单说明弹窗-->
    <div v-if="cancelDialog" class="dialogMantle">
      <div class="dialogCtn">
        <img @click="cancelDialog=false;" src="../../assets/rsStandard/关闭弹窗.png" height="40" width="40"/>
        <div class="dialogTitle" style="margin-top: 50px;">
          请告诉我们您取消订单的原因
        </div>
        <div class="dialogTxt" style="margin-top: 50px;height:130px;">
          <a-textarea
              v-model="cancelReason"
              placeholder="请输入您取消订单的原因以便我们更好地为您服务"
              :autoSize="false"
              style="width: 600px;height:130px;font-weight: 300"

          />
        </div>
        <div @click="cancelOrder()" style="cursor: pointer;width: 160px;height: 40px;line-height:40px;text-align:center;background: #0066CC;border-radius: 8px;color:white;margin-left: auto;margin-right: auto;margin-top: 45px;">
          确定取消订单
        </div>

      </div>
    </div>
    <!--选择套件弹窗-->
    <div v-if="chooseRepositoryDialog" class="dialogMantle">
      <div class="dialogCtn">
        <img @click="chooseRepositoryDialog=false;" src="../../assets/rsStandard/关闭弹窗.png" height="40" width="40"/>
        <div class="dialogTitle" style="margin-top: 50px;">
          请选择您的标准版套件
        </div>
        <div class="shadowCount-s">
          <div class="shadowCountyButton-s" v-for="(item, index) in orderDetail.repCountyList" :key="'repCountyList'+index" @click="gotoRSManage(item,orderDetail.createTime)">{{ item.subName }}</div>
        </div>
        <!-- <div style="display:flex;justify-content:center;align-items:center;width:100%;margin-top: 50px;height:130px;">
          <div v-for="item in orderDetail.repCountyList" :key="item.repositoryId" class="buttonNormal" style="margin-right: 20px;"
          @click="gotoRSManage(item,orderDetail.createTime)"
          >
            {{item.subName}}
          </div>

        </div> -->
      </div>
    </div>
    <!--专票邮寄信息弹窗-->
    <div v-if="zp_infoDialog" class="dialogMantle">
      <div class="dialogCtn">
        <img @click="zp_infoDialog=false;" src="../../assets/rsStandard/关闭弹窗.png" height="40" width="40"/>
        <div class="dialogTitle" style="margin-top: 50px;">
          订单 {{orderDetail.id}} 发票寄送信息
        </div>
        <div style="width: 450px;height: 160px;margin-top: 50px;margin-left: auto;margin-right: auto;font-size: 17px;">
          <div style="width: 450px;height: 60px;line-height: 60px;">
            快递信息：{{invoiceAddress.expressCompany}}
          </div>
          <div style="width: 450px;height: 60px;line-height: 60px;">
            物流订单：{{invoiceAddress.expressId}}
          </div>
        </div>
        <div @click="zp_infoDialog=false;" style="width:128px;height:44px;background:#0066cc;border-radius: 8px;line-height: 44px;text-align:center;color:#ffffff;margin-right: auto;margin-left: auto;cursor:pointer;">
          确定
        </div>

      </div>
    </div>
    <div v-if="showAlert" class="alertTip">
      {{alertContent}}
    </div>
    <!--申请发票弹窗-->
    <div v-if="applyInvoiceDialog" class="dialogMantle">
      <div class="dialogCtn2">
        <img @click="applyInvoiceDialog=false;" src="../../assets/rsStandard/关闭弹窗.png" height="40" width="40"/>
        <div class="dialogTitle" style="margin-top: 30px;">
          申请开票
        </div>
        <div class="applyInvoiceCtn" style="width: 100%;height: auto">
          <div class="contractSelect1">
            <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;" v-if="invoiceType==1">
            <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;cursor: pointer;" v-if="invoiceType!=1" @click="invoiceType=1">
            <div class="contractText1">个人电子发票</div>
            <div class="contractText2">(默认)</div>
            <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 395px;" v-if="invoiceType==2">
            <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 395px;cursor: pointer;" v-if="invoiceType!=2" @click="invoiceType=2">
            <div class="contractText1" style="left: 423px;">企业普通电子发票</div>
            <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left:770px;" v-if="invoiceType==3">
            <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 770px;cursor: pointer;" v-if="invoiceType!=3" @click="invoiceType=3">
            <div class="contractText1" style="left: 800px;">企业增值税专用发票</div>
          </div>
          <div class="greyInvoice" :class="[invoiceType==2 ? 'greyInvoice1':'', invoiceType==3 ? 'greyInvoice2':'']">
            <div class="qyInvoice" v-if="invoiceType==2">
              <div class="qyText1" id="qyText1Id">单位名称：</div>
              <div class="greyInput" id="greyInput1Id">
                <input type="text" class="inputContent" placeholder="" v-model="qyCompany" @focus="inputBlack(2)"/>
              </div>
              <div class="qyText1" id="qyText2Id" style="top: 65px;">纳税人识别号：</div>
              <div class="greyInput" id="greyInput2Id" style="top: 55px;">
                <input type="text" class="inputContent" placeholder="" v-model="qyNumber" @focus="inputBlack(3)"/>
              </div>
              <div class="qyText1" id="qyText2Id" style="top: 120px;">发票备注：</div>
              <div class="greyRemarks" style="top: 120px;">
                <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;" v-if="showSellerInfoStatus=='1'">
                <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;cursor: pointer;" v-if="showSellerInfoStatus!='1'" @click="showSellerInfoStatus='1'">
                <div class="contractText1">销售方银行信息</div>
                <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 195px;" v-if="showSellerInfoStatus=='0'">
                <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 195px;cursor: pointer;" v-if="showSellerInfoStatus!='0'" @click="showSellerInfoStatus='0'">
                <div class="contractText1" style="left: 223px;">不展示销售方银行信息</div>
              </div>
            </div>
            <div class="zpInvoice" v-if="invoiceType==3">
              <div class="qyText1" id="qyText3Id">单位名称：</div>
              <div class="greyInput" id="greyInput3Id">
                <input type="text" class="inputContent" placeholder="" v-model="zpCompany" @focus="inputBlack(4)"/>
              </div>
              <div class="qyText1" style="top: 65px;" id="qyText4Id">纳税人识别号：</div>
              <div class="greyInput" style="top: 55px;" id="greyInput4Id">
                <input type="text" class="inputContent" placeholder="" v-model="zpNumber" @focus="inputBlack(5)"/>
              </div>
              <div class="qyText1" id="qyText2Id" style="top: 120px;">发票备注：</div>
              <div class="greyRemarks" style="top: 120px;">
                <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;" v-if="showSellerInfoStatus=='1'">
                <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;cursor: pointer;" v-if="showSellerInfoStatus!='1'" @click="showSellerInfoStatus='1'">
                <div class="contractText1">销售方银行信息</div>
                <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 195px;" v-if="showSellerInfoStatus=='0'">
                <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 195px;cursor: pointer;" v-if="showSellerInfoStatus!='0'" @click="showSellerInfoStatus='0'">
                <div class="contractText1" style="left: 223px;">不展示销售方银行信息</div>
              </div>
              <div class="zpLine"></div>
              <div class="zpText1">资质信息</div>
              <div class="qyText1" style="top: 215px;" id="qyText5Id">注册地址：</div>
              <div class="greyInput" style="top: 205px;"  id="greyInput5Id">
                <input type="text" class="inputContent" placeholder="" v-model="address" @focus="inputBlack(6)"/>
              </div>
              <div class="qyText1" style="top: 270px;"  id="qyText6Id">注册电话：</div>
              <div class="greyInput" style="top: 260px;"  id="greyInput6Id">
                <input type="text" class="inputContent" placeholder="" v-model="phone" @focus="inputBlack(7)"/>
              </div>
              <div class="qyText1" style="top: 325px;"  id="qyText7Id">开户银行：</div>
              <div class="greyInput" style="top: 315px;" id="greyInput7Id">
                <input type="text" class="inputContent" placeholder="" v-model="bank" @focus="inputBlack(8)"/>
              </div>
              <div class="qyText1" style="top: 380px;"  id="qyText8Id">银行账号：</div>
              <div class="greyInput" style="top: 370px;" id="greyInput8Id">
                <input type="text" class="inputContent" placeholder="" v-model="bankNumber" @focus="inputBlack(9)"/>
              </div>
            </div>
          </div>

        </div>
        <div style="width: 100%;height: 50px;line-height: 50px;margin-top: 20px;margin-bottom: 20px">
          <div @click="confirmApplyInvoice" class="buttonPrimary" style="margin-left: auto;margin-right: auto;">
            确认开票
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import HomeFooter1 from "@comp/HomeFooter1.vue";
export default {
  name: "rsStandardOrderDetail",
  components:{
    HomeFooter1
  },
  data(){
    return{
      orderId:'',
      showAlert:false,
      alertContent:'',
      progressStat:2,
      orderDetail:{},
      cancelDialog:false,
      cancelReason:'',
      chooseRepositoryDialog:false,//选择套件
      zp_infoDialog:false,
      invoiceAddress:{},
      applyInvoiceDialog:false,
      invoiceType:1,
      qyCompany:"",
      qyNumber:"",
      zpCompany:"",
      zpNumber:"",
      address:"",
      phone:"",
      bank:"",
      bankNumber:"",
      isShadow:0,
      showSellerInfoStatus:'1',

    }
  },
  methods:{
    confirmApplyInvoice() {
      let params={}
      params.orderId=this.orderId;
      if(this.invoiceType==1){
        let invoiceType="gr"
        params.invoiceType=invoiceType
      }else if(this.invoiceType==2){
        if((!this.qyCompany)||(!this.qyNumber)){
          alert("信息不全，请补全")
          return
        }
        let invoiceType="qy"
        params.invoiceType=invoiceType
        params.companyName=this.qyCompany
        params.number=this.qyNumber
        params.showSellerInfoStatus=this.showSellerInfoStatus


      }else if(this.invoiceType==3){
        if((!this.zpCompany)||(!this.zpNumber)||(!this.bank)||(!this.bankNumber)||(!this.address)||(!this.phone)){
          alert("信息不全，请补全")
          return
        }

        let invoiceType="zp"
        params.invoiceType=invoiceType
        params.companyName=this.zpCompany
        params.number=this.zpNumber
        params.bank=this.bank
        params.bankNumber=this.bankNumber
        params.address=this.address
        params.phone=this.phone
        params.showSellerInfoStatus=this.showSellerInfoStatus

      }
      console.log(params)
      this.axios.post("/tilesapi/tiles/county/invoice/add",params, {
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      }).then((res)=>{
        console.log(res);
        if(res.data.code==200){
          this.getOrderDetail();
          this.applyInvoiceDialog=false;
        }else{
          alert("申请不成功，请重试或联系商务经理")
        }
      })
    },
    applyInvoice:function () {
      this.applyInvoiceDialog=true;
    },
    inputBlack(i){
      if(i==1){
        let contractNameId = document.getElementById("contractNameId")
        contractNameId.style.color="#3A3A3A"
        let contractInputId = document.getElementById("contractInputId")
        contractInputId.style.borderBottom="1px solid #3A3A3A"
      }else if(i==2){
        let qyText1Id = document.getElementById("qyText1Id")
        qyText1Id.style.color="#3A3A3A"
        let greyInput1Id = document.getElementById("greyInput1Id")
        greyInput1Id.style.border="1px solid #3A3A3A"
      }else if(i==3){
        let qyText2Id = document.getElementById("qyText2Id")
        qyText2Id.style.color="#3A3A3A"
        let greyInput2Id = document.getElementById("greyInput2Id")
        greyInput2Id.style.border="1px solid #3A3A3A"
      }else if(i==4){
        let qyText2Id = document.getElementById("qyText3Id")
        qyText2Id.style.color="#3A3A3A"
        let greyInput2Id = document.getElementById("greyInput3Id")
        greyInput2Id.style.border="1px solid #3A3A3A"
      }else if(i==5){
        let qyText2Id = document.getElementById("qyText4Id")
        qyText2Id.style.color="#3A3A3A"
        let greyInput2Id = document.getElementById("greyInput4Id")
        greyInput2Id.style.border="1px solid #3A3A3A"
      }else if(i==6){
        let qyText2Id = document.getElementById("qyText5Id")
        qyText2Id.style.color="#3A3A3A"
        let greyInput2Id = document.getElementById("greyInput5Id")
        greyInput2Id.style.border="1px solid #3A3A3A"
      }else if(i==7){
        let qyText2Id = document.getElementById("qyText6Id")
        qyText2Id.style.color="#3A3A3A"
        let greyInput2Id = document.getElementById("greyInput6Id")
        greyInput2Id.style.border="1px solid #3A3A3A"
      }else if(i==8){
        let qyText2Id = document.getElementById("qyText7Id")
        qyText2Id.style.color="#3A3A3A"
        let greyInput2Id = document.getElementById("greyInput7Id")
        greyInput2Id.style.border="1px solid #3A3A3A"
      }else if(i==9){
        let qyText2Id = document.getElementById("qyText8Id")
        qyText2Id.style.color="#3A3A3A"
        let greyInput2Id = document.getElementById("greyInput8Id")
        greyInput2Id.style.border="1px solid #3A3A3A"
      }

    },
    getKey() {
      return localStorage.getItem("token");
    },
    showInvoice:function () {
      console.log(this.orderDetail)
      //电子发票
      // if(this.orderDetail.invoiceType=='gr'||this.orderDetail.invoiceType=='qy'){
        window.open(this.orderDetail.invoiceUrl);
      // }
      //纸质发票
      // else {
      //   this.axios.defaults.withCredentials = true;
      //   let requestData=new FormData();
      //   requestData.append("requirementId",this.orderId)
      //   this.axios.post("/accessapi/invoice/getInvoiceDeliveryInfo",
      //       requestData,
      //       {
      //         headers: {
      //           Authorization: "Bearer " + localStorage.getItem("token")
      //         }
      //       }
      //   )
      //       .then((res) => {
      //         console.log('发票')
      //         console.log(res)
      //         this.invoiceAddress=res.data.data;
      //       });
      //   this.zp_infoDialog=true;
      // }
    },
    openContract:function () {
      window.open(this.orderDetail.contractUrl)
    },
    gotoRSManage(item,time) {
      console.log(item);
      this.$store.state.repositoryId=item.repositoryId
      this.$store.state.createTime=time
      this.$store.state.subName=item.subName
      this.$router.push("/RSsserviceManage")
    },
    goRSmanageStandard(item){
      this.$store.state.repositoryId=item.repStandardList[0].repositoryId
      this.$store.state.createTime=item.createTime
      // this.$store.state.item=item
      console.log(this.$store.state.repositoryId,this.$store.state.createTime,this.$store.state.item)

      this.$router.push("/RSsserviceManage");
    },
    evalueteOrder:function () {
      this.$router.push({name:'standardOrderAppraise',params:{orderId:this.orderDetail.id}});
    },
    payThisOrder:function () {
      this.$router.push({name:'standardOrderPayment',params:{orderId:this.orderDetail.id}});
    },
    cancelOrder:function () {
      if(!this.cancelReason){
        this.showAlert=true;
        this.alertContent='请填写原因';
        let that=this;
        setTimeout(()=>{that.showAlert=false;that.alertContent=""},5000)
        return;
      }
      this.axios.post('/tilesapi/tiles/register/cancelTileOrder',
          {id:this.orderId,reasonType:'',reasonContent:this.cancelReason},
          {headers: {Authorization: "Bearer " + localStorage.getItem("token")}}
      ).then((res) => {
        console.log(res)
        this.getOrderDetail();
        this.cancelDialog=false;
      })
    },
    getOrderDetail:function () {
      this.axios.get('/tilesapi/tiles/standard/order/queryStandardOrderByOrderId?orderId='+this.orderId,
          {headers: {Authorization: "Bearer " + localStorage.getItem("token")}}
      ).then((res) => {
        console.log(res)
        if(res.data.code==200){
          this.orderDetail=res.data.data;
          let quarters=[];
          for(let i=0;i<this.orderDetail.repStandardList.length;i++){
            quarters.push(this.orderDetail.repStandardList[i].subName)
          }
          this.orderDetail.quarters=quarters;
          switch (this.orderDetail.status) {
            case '订单提交':
              this.progressStat=2;
              break;
            case '待确认':
              this.progressStat=3;
              break;
            case '已确认':
              this.progressStat=3;
              break;
            case '已驳回':
              this.progressStat=3;
              break;
            case '已取消':
              this.progressStat=3;
              break;
            case '已交付':
              if(this.orderDetail.evaluateStatus=='未评价'){
                this.progressStat=4;
              }
              else if(this.orderDetail.evaluateStatus=='已评价'){
                this.progressStat=5;
              }
              break;
            default:
              break;
          }
          if(this.orderDetail.invoiceInfo){
            // if(this.orderDetail.invoiceInfo.type=="qy"){
            //
            // }
            // else if(this.orderDetail.invoiceInfo.type=="qy"){
            //
            // }else if(this.orderDetail.invoiceInfo.type=="gr"){
            //
            // }
                this.qyCompany=this.orderDetail.invoiceInfo.companyName
                this.qyNumber=this.orderDetail.invoiceInfo.number
                this.zpCompany=this.orderDetail.invoiceInfo.companyName
                this.zpNumber=this.orderDetail.invoiceInfo.number
                this.address=this.orderDetail.invoiceInfo.address
                this.phone=this.orderDetail.invoiceInfo.phone
                this.bank=this.orderDetail.invoiceInfo.bank
                this.bankNumber=this.orderDetail.invoiceInfo.bankNumber
          }
        }
      })
    },
  },
  mounted() {
    this.orderId=this.$route.query.orderId;
    console.log("orderId:")
    this.getOrderDetail();
  }
}
</script>

<style scoped lang="scss">
.applyInvoiceCtn{
  .contractInfo{
    position: relative;
    margin-top: 20px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: auto;
    background: #FFFFFF;
    border-radius: 16px;
    overflow: hidden;
  }
  .greyInvoice{
    position: relative;
    margin-top: 20px;
    margin-left: 52px;
    width: 1175px;
    height: 1px;
    /* background-color: plum; */
    overflow: hidden;
  }
  .greyInvoice1{
    position: relative;
    margin-top: 20px;
    margin-left: 52px;
    width: 1100px;
    height: 150px;
    /* background-color: plum; */
    overflow: hidden;
  }
  .greyInvoice2{
    position: relative;
    margin-top: 20px;
    margin-left: 52px;
    width: 1100px;
    height: 430px;
    overflow: hidden;
  }
  .qyInvoice{
    position: absolute;
    width: 1100px;
    height: 150px;
  }
  .zpInvoice{
    position: absolute;
    top: 0;
    left: 0;
    width: 1100px;
    height: 430px;
  }
  .qyText1{
    position: absolute;
    top: 10px;
    left: 240px;
    width: 200px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 20px;
    text-align: right;
  }
  .greyInput{
    position: absolute;
    top: 0px;
    left: 445px;
    width: 380px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #979797;
  }
  .inputContent{
    position: absolute;
    top: 5px;
    left: 5px;
    width: 370px;
    height: 30px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3a3a3a;
    line-height: 30px;
    position: absolute;
    border: none;
    background: none;
    outline: none;
    padding: 0;
  }
  .zpLine{
    position: absolute;
    top: 170px;
    left: 325px;
    width: 500px;
    height: 1px;
    border-bottom: 1px #979797 dashed;
  }
  .zpText1{
    position: absolute;
    top: 161px;
    left: 530px;
    width: 80px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color:  #3A3A3A;
    line-height: 20px;
    text-align: center;
    background-color: #fff;
  }
  .contractSelect{
    position: relative;
    margin-top: 104px;
    margin-left: 60px;
    padding-left: 20px;
    width: 1160px;
    height: 54px;
    background: #F5F5F6;
    border-radius: 8px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1D1D28;
    line-height: 54px;
  }
  .redTip{
    position: absolute;
    top: 7px;
    left: calc(50% - 300px);
    width: 600px;
    height: 40px;
    background: #FF4040;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    opacity: 1;
  }
  .contractSelect1{
    position: relative;
    width: 1160px;
    height: 47px;
    margin-top: 55px;
    margin-left: 60px;
    /* background-color: pink; */
  }
  .contractText1{
    position: absolute;
    left: 45px;
    width: 256px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 20px;
  }
  .contractText1{
    position: absolute;
    left: 45px;
    width: 256px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 20px;
  }
  .contractText2{
    position: absolute;
    top: 30px;
    left: 45px;
    width:40px;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #979797;
    line-height: 17px;
  }
}
.blueTxt{
  color:#0066CC;
  cursor:pointer;
}
.buttonNormal{
  width: 200px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 8px;
  border: 1px solid #3A3A3A;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  cursor:pointer;
}
.alertTip{
  position:fixed;
  top:150px;
  left:50%;
  margin-left: -300px;
  width: 600px;
  height: 40px;
  background: #FF6666;
  box-shadow: 0px 0px 3px 0px rgba(0,0,0,0.5);
  border-radius: 8px;
  line-height: 40px;
  text-align: center;
  color: #ffffff;
  z-index: 1000000001;
}
.dialogMantle {
  z-index: 1000000000;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(80, 80, 80, 0.5);
  .dialogCtn2{
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -600px;
    margin-top: -300px;
    width: 1200px;
    min-height: 300px;
    height: auto;
    background: #FFFFFF;
    border-radius: 16px;
    padding: 1px;
    .dialogTitle{
      width:100%;
      height:30px;
      line-height: 30px;
      text-align: center;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3A3A3A;
    }
    .dialogTxt{
      height:25px;
      line-height: 25px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 100%;
      font-weight: 300;
      color: #575757;
    }
    img {
      position: absolute;
      right: -55px;
      top: 0px;
      cursor: pointer;
    }
    .buttonPrimary{
      width: 125px;
      height: 40px;
      background: #0066CC;
      border-radius: 8px;
      border: 1px solid #0066CC;
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      cursor:pointer;
    }
  }
  .dialogCtn {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -400px;
    margin-top: -200px;
    width: 800px;
    height: 400px;
    background: #FFFFFF;
    border-radius: 16px;
    .dialogTitle{
      width:100%;
      height:30px;
      line-height: 30px;
      text-align: center;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3A3A3A;
    }
    .dialogTxt{
      height:25px;
      line-height: 25px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 100%;
      font-weight: 300;
      color: #575757;
    }
    img {
      position: absolute;
      right: -55px;
      top: 0px;
      cursor: pointer;
    }
  }
}
.orderDetailCtn{
  width: 1280px;
  min-height: 560px;
  background: #FFFFFF;
  border-radius: 16px;
  padding-top: 1px;
  .orderdetail_title{
    width: 100%;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3A3A3A;
    line-height: 22px;
    text-align: left;
  }
  .detailTable{
    width: 100%;
    margin-top:10px;
    tr{
      min-height:35px;
      line-height: 35px;
      font-size: 14px;
      vertical-align: top;
    }
  }

  .detailButtonCtn{
    margin-top: 34px;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 40px;
    .buttonNormal{
      width: 125px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 8px;
      border: 1px solid #3A3A3A;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3A3A3A;
      cursor:pointer;
    }
    .buttonPrimary{
      width: 125px;
      height: 40px;
      background: #0066CC;
      border-radius: 8px;
      border: 1px solid #0066CC;
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      cursor:pointer;
    }
  }
}
.bottomTip{
  margin-top: 80px;
  margin-bottom: 80px;
  height:25px;
  line-height: 25px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #3A3A3A;
}
.mainCtn{
  width: 1280px;
  min-height: 300px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  .title{
    margin-top: 126px;
    position:relative;
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    text-align: center;
  }
}
.progressButton {
  width: 150px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.progressCircle_Text_time {
  width: 100%;
  text-align: center;
  height: 16px;
  line-height: 16px;
  font-weight: 500;
  color: #3A3A3A;
  font-size: 12px;
}

.progressCircle_Text_name {
  width: 100%;
  text-align: center;
  height: 20px;
  line-height: 20px;
  font-weight: 400;
  color: #3A3A3A;
  font-size: 16px;
}

.progressCircle_Text {
  position: absolute;
  top: 38px;
  left: -30px;
  width: 100px;
  height: auto;
}

.progressCircle_blue {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #0066CC;
  border-radius: 50%;
}
.progressCircle_red {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #FF4040;
  border-radius: 50%;
  font-size: 18px;
  color:#ffffff;
}

.progressLine_blue {
  z-index: 2;
  position: relative;
  left: -2px;
  top: 1px;
  width: 186px;
  height: 4px;
  background: #0066CC;
}

.progressLine_gray {
  position: relative;
  width: 182px;
  height: 6px;
  background: #CCCCCC;
  float: left;
  margin-top: 14px;
  margin-left: -1px;
}

.progressCircle_gray {
  position: relative;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 50%;
  background: #CCCCCC;
  float: left;
  margin-left: -1px;
  font-weight: 900;
  color: #FFFFFF;
}

.progressBar {
  position: relative;
  width: 100%;
  height: 45px;
}

.progressBarCtn {
  width: 883px;
  height: 107px;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
}
.shadowCount-s{
    position: absolute;
    top: 50%;
    left:50%;
    transform: translate(-50%,-35%);
    width:640px;
    min-height: 44px;
    height:auto;
}
.shadowCountyButton-s{
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 15px;
    width: 200px;
    height: 44px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #979797;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #3A3A3A;
    line-height: 44px;
    cursor: pointer;
    text-align: center;
}
.greyRemarks{
    position: absolute;
    top: 0px;
    left: 445px;
    width: 380px;
    height: 40px;
    border-radius: 8px;
  }
</style>
